import { lazy, type ComponentType } from "react";

export function withCompassLayout<P extends object>(
  importFn: () => Promise<{ default: ComponentType<P> }>
) {
  return lazy(async () => {
    const [{ default: Component }, { CompassLayout }] = await Promise.all([
      importFn(),
      import("./CompassLayout"),
    ]);
    return {
      default: function CompassLayoutWrapped(props: P) {
        return (
          <CompassLayout>
            <Component {...props} />
          </CompassLayout>
        );
      },
    };
  });
}
